module.exports = __webpack_public_path__ + "assets/img/btn-download-pc-4b836605.png";